"use client";

import { c as _c } from "react/compiler-runtime";
import { QueryKey } from "@/components/react-query-wrapper/ReactQueryWrapper";
import type { ApiDrop } from "@/generated/models/ApiDrop";
import { useCallback, useMemo } from "react";
import type { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { DropSize } from "@/helpers/waves/drop.helpers";
import { useWaveData } from "@/hooks/useWaveData";
import { DROP_DETAIL_STALE_TIME_MS } from "@/services/api/drop-api";
import { fetchDropMetadataByIdV2 } from "@/services/api/wave-drops-v2-api";
import { useQuery } from "@tanstack/react-query";
export const useSingleWaveDropData = (initialDrop, onClose) => {
  const $ = _c(27);
  let t0;
  if ($[0] !== onClose) {
    t0 = () => {
      onClose();
    };
    $[0] = onClose;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const onWaveNotFound = t0;
  let t1;
  if ($[2] !== initialDrop.wave.id || $[3] !== onWaveNotFound) {
    t1 = {
      waveId: initialDrop.wave.id,
      onWaveNotFound
    };
    $[2] = initialDrop.wave.id;
    $[3] = onWaveNotFound;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    data: wave
  } = useWaveData(t1);
  let t2;
  if ($[5] !== initialDrop.id) {
    t2 = [QueryKey.DROP, {
      drop_id: initialDrop.id,
      view: "metadata"
    }];
    $[5] = initialDrop.id;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== initialDrop.id || $[8] !== initialDrop.metadata) {
    t3 = t4 => {
      const {
        signal
      } = t4;
      return fetchDropMetadataByIdV2({
        dropId: initialDrop.id,
        priorityMetadata: initialDrop.metadata,
        signal
      });
    };
    $[7] = initialDrop.id;
    $[8] = initialDrop.metadata;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== initialDrop.id) {
    t4 = initialDrop.id.trim();
    $[10] = initialDrop.id;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = t4.length > 0;
  let t6;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5) {
    t6 = {
      queryKey: t2,
      queryFn: t3,
      enabled: t5,
      staleTime: DROP_DETAIL_STALE_TIME_MS
    };
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const {
    data: hydratedMetadata
  } = useQuery(t6);
  const t7 = hydratedMetadata ?? initialDrop.metadata;
  let t8;
  if ($[16] !== initialDrop || $[17] !== t7) {
    t8 = {
      ...initialDrop,
      metadata: t7
    };
    $[16] = initialDrop;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  const drop = t8;
  let t9;
  if ($[19] !== drop || $[20] !== initialDrop.stableHash || $[21] !== initialDrop.stableKey) {
    t9 = {
      ...drop,
      type: DropSize.FULL as const,
      stableHash: initialDrop.stableHash,
      stableKey: initialDrop.stableKey
    };
    $[19] = drop;
    $[20] = initialDrop.stableHash;
    $[21] = initialDrop.stableKey;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const extendedDrop = t9;
  let t10;
  if ($[23] !== drop || $[24] !== extendedDrop || $[25] !== wave) {
    t10 = {
      drop,
      wave,
      extendedDrop
    };
    $[23] = drop;
    $[24] = extendedDrop;
    $[25] = wave;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  return t10;
};